module.exports = __webpack_public_path__ + "newslaundry_logo-5eb0c0029b58ffa7d085.png";